import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { AuxIconName } from '@shared/components/icon/icon';
import { IconComponent } from '@shared/components/icon/icon.component';
import { TooltipDirective } from '@shared/directives/tooltip.directive';

import { QCGridData } from '../../../period-close.model';

export type QCMonthEstimateCellRendererParams = ICellRendererParams<QCGridData> & {
  iconName: AuxIconName;
  isDisabled: (params: ICellRendererParams<QCGridData>) => boolean;
  onClicked: (params: ICellRendererParams<QCGridData>) => void;
};

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '(click)': 'onClick()',
  },
  imports: [IconComponent, TooltipDirective],
  styles: `
    :host {
      @apply flex w-full items-center justify-end;
    }
  `,
  template: `
    <div class="truncate">{{ params.valueFormatted }}</div>
    @if (showIcon) {
      <aux-icon
        class="ml-[4px] flex-shrink-0"
        [class.cursor-not-allowed]="iconDisabled"
        [class.text-aux-gray]="iconDisabled"
        [class.cursor-pointer]="!iconDisabled"
        [class.text-aux-blue]="!iconDisabled"
        [size]="20"
        [name]="iconName"
        [auxTooltip]="iconDisabled ? discountDisabledMessage : ''"
      />
    }
  `,
})
export class QCMonthEstimateCellRendererComponent implements ICellRendererAngularComp {
  discountDisabledMessage = 'Manual adjustments for Discount can be made in Period Close Checklist';
  iconDisabled = false;
  iconName: AuxIconName = 'Eye';
  params!: QCMonthEstimateCellRendererParams;
  showIcon = true;
  tooltip = '';

  agInit(params: QCMonthEstimateCellRendererParams): void {
    this.params = params;
    this.showIcon = !params.node.isRowPinned();
    this.iconName = params.iconName;
    this.iconDisabled = params.isDisabled(params);
  }

  onClick = () => !this.iconDisabled && this.params.onClicked(this.params);

  refresh = (): boolean => false;
}
